import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";

function WhatsappSetup() {
  const [activeTab, setActiveTab] = useState("configuration");
  const [activeModuleType, setActiveModuleType] = useState("lab");
  
  const [configData, setConfigData] = useState({
    fast2sms_api_key: '',
    whatsapp_phone_number: '',
    whatsapp_business_id: '',
    alertMsg: '',
    alertMsgTyp: '',
    isAlert: false,
  });

  const [templates, setTemplates] = useState([]);
  const [newTemplate, setNewTemplate] = useState({
    id: null,
    template_name: '',
    template_id: '',
    message_id: '', // ✅ Added message_id
    template_content: '',
    module_type: 'lab',
  });

  const [isEditing, setIsEditing] = useState(false);

  const [moduleSettings, setModuleSettings] = useState({
    lab: {
      report_to_patient: false,
      bill_pdf_to_patient: false,
      whatsapp_notification: false,
    },
    opd: {
      bill_to_patient: false,
      digital_prescription: false,
      whatsapp_notification: false,
    },
    ipd: {
      admission_bill: false,
      bill_pdf: false,
      whatsapp_notification: false,
    },
    pharmacy: {
      sale_pdf_bill: false,
      return_pdf_bill: false,
      sale_whatsapp: false,
    },
  });

  useEffect(() => {
    loadConfiguration();
    loadTemplates();
    loadModuleSettings();
  }, []);

  const loadConfiguration = async () => {
    try {
      const fd = new FormData();
      const response = await axios.post(AppConst.BASE_URL + AppConst.getFast2SMSConfig, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.status && response.data.config) {
        setConfigData(prev => ({
          ...prev,
          ...response.data.config
        }));
      }
    } catch (error) {
      console.error("Error loading configuration:", error);
    }
  };

  const loadTemplates = async () => {
    try {
      const fd = new FormData();
      const response = await axios.post(AppConst.BASE_URL + AppConst.getTemplates, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.status) {
        setTemplates(response.data.templates || []);
      }
    } catch (error) {
      console.error("Error loading templates:", error);
    }
  };

  const loadModuleSettings = async () => {
    try {
      const fd = new FormData();
      const response = await axios.post(AppConst.BASE_URL + AppConst.getModuleSettings, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      
      if (response.data.status && response.data.settings) {
        setModuleSettings(response.data.settings);
      }
    } catch (error) {
      console.error("Error loading module settings:", error);
    }
  };

  const handleConfigChange = (e) => {
    const { name, value } = e.target;
    setConfigData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleConfigSubmit = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append('fast2sms_api_key', configData.fast2sms_api_key);
    fd.append('whatsapp_phone_number', configData.whatsapp_phone_number);
    fd.append('whatsapp_business_id', configData.whatsapp_business_id);

    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.saveFast2SMSConfig, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      setConfigData(prev => ({
        ...prev,
        isAlert: true,
        alertMsg: response.data.message || "Configuration saved successfully",
        alertMsgTyp: response.data.status ? "success" : "danger",
      }));

      setTimeout(() => {
        setConfigData(prev => ({ ...prev, isAlert: false }));
      }, 3000);
    } catch (error) {
      setConfigData(prev => ({
        ...prev,
        isAlert: true,
        alertMsg: "Failed to save configuration",
        alertMsgTyp: "danger",
      }));
    }
  };

  const handleTemplateChange = (e) => {
    const { name, value } = e.target;
    setNewTemplate(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEditTemplate = (template) => {
    setNewTemplate({
      id: template.id,
      template_name: template.template_name,
      template_id: template.template_id,
      message_id: template.message_id || '', // ✅ Include message_id
      template_content: template.template_content,
      module_type: template.module_type,
    });
    setIsEditing(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleCancelEdit = () => {
    setNewTemplate({
      id: null,
      template_name: '',
      template_id: '',
      message_id: '', // ✅ Reset message_id
      template_content: '',
      module_type: 'lab',
    });
    setIsEditing(false);
  };

  const handleAddTemplate = async (e) => {
    e.preventDefault();

    const fd = new FormData();
    fd.append('template_name', newTemplate.template_name);
    fd.append('template_id', newTemplate.template_id);
    fd.append('message_id', newTemplate.message_id); // ✅ Include message_id
    fd.append('template_content', newTemplate.template_content);
    fd.append('module_type', newTemplate.module_type);
    
    if (isEditing && newTemplate.id) {
      fd.append('id', newTemplate.id);
    }

    try {
      const endpoint = isEditing ? AppConst.updateTemplate : AppConst.saveTemplate;
      const response = await axios.post(AppConst.BASE_URL + endpoint, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.data.status) {
        setNewTemplate({
          id: null,
          template_name: '',
          template_id: '',
          message_id: '', // ✅ Reset message_id
          template_content: '',
          module_type: 'lab',
        });
        setIsEditing(false);
        loadTemplates();
        
        setConfigData(prev => ({
          ...prev,
          isAlert: true,
          alertMsg: isEditing ? "Template updated successfully" : "Template added successfully",
          alertMsgTyp: "success",
        }));

        setTimeout(() => {
          setConfigData(prev => ({ ...prev, isAlert: false }));
        }, 3000);
      }
    } catch (error) {
      setConfigData(prev => ({
        ...prev,
        isAlert: true,
        alertMsg: isEditing ? "Failed to update template" : "Failed to add template",
        alertMsgTyp: "danger",
      }));
    }
  };

  const handleDeleteTemplate = async (templateId) => {
    if (!window.confirm("Are you sure you want to delete this template?")) return;

    const fd = new FormData();
    fd.append('template_id', templateId);

    try {
      const response = await axios.post(AppConst.BASE_URL + AppConst.deleteTemplate, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      if (response.data.status) {
        loadTemplates();
        setConfigData(prev => ({
          ...prev,
          isAlert: true,
          alertMsg: "Template deleted successfully",
          alertMsgTyp: "success",
        }));

        setTimeout(() => {
          setConfigData(prev => ({ ...prev, isAlert: false }));
        }, 3000);
      }
    } catch (error) {
      console.error("Error deleting template:", error);
    }
  };

  const handleToggleChange = async (module, setting) => {
    const newValue = !moduleSettings[module][setting];
    
    const updatedSettings = {
      ...moduleSettings,
      [module]: {
        ...moduleSettings[module],
        [setting]: newValue
      }
    };

    setModuleSettings(updatedSettings);

    try {
      const fd = new FormData();
      fd.append('module_type', module);
      fd.append('setting_name', setting);
      fd.append('setting_value', newValue ? '1' : '0');

      await axios.post(AppConst.BASE_URL + AppConst.updateModuleSetting, fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    } catch (error) {
      console.error("Error updating setting:", error);
      setModuleSettings(moduleSettings);
    }
  };

  const renderConfigurationTab = () => (
    <div className="row">
      {/* Configuration Section */}
      <div className="col-xxl-12">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title mb-3">Fast2SMS WhatsApp Configuration</h5>
            
            <form onSubmit={handleConfigSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Fast2SMS API Key *</label>
                  <input
                    name="fast2sms_api_key"
                    onChange={handleConfigChange}
                    value={configData.fast2sms_api_key}
                    className="form-control"
                    placeholder="Enter Fast2SMS API Key"
                    type="text"
                    required
                  />
                  <small className="text-muted">Get your API key from Fast2SMS Dev API section</small>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">WhatsApp Phone Number</label>
                  <input
                    name="whatsapp_phone_number"
                    onChange={handleConfigChange}
                    value={configData.whatsapp_phone_number}
                    className="form-control"
                    placeholder="Enter WhatsApp Business Number"
                    type="text"
                  />
                  <small className="text-muted">Your registered WhatsApp Business number</small>
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label">WhatsApp Business ID</label>
                  <input
                    name="whatsapp_business_id"
                    onChange={handleConfigChange}
                    value={configData.whatsapp_business_id}
                    className="form-control"
                    placeholder="Enter WhatsApp Business Account ID"
                    type="text"
                  />
                  <small className="text-muted">Get this from Fast2SMS WhatsApp API section</small>
                </div>

                {configData.isAlert && (
                  <div className="col-lg-12 mb-3">
                    <div className={`alert alert-${configData.alertMsgTyp} material-shadow`} role="alert">
                      {configData.alertMsg}
                    </div>
                  </div>
                )}

                <div className="col-lg-12">
                  <div className="text-end">
                    <button type="submit" className="btn btn-primary">Save Configuration</button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Templates Section */}
      <div className="col-xxl-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="card-title mb-0">WhatsApp Templates</h5>
              {isEditing && (
                <span className="badge bg-warning">
                  <i className="ri-edit-line me-1"></i>
                  Editing Template
                </span>
              )}
            </div>
            
            <form onSubmit={handleAddTemplate} className="mb-4">
              <div className="row">
                <div className="col-md-3 mb-3">
                  <label className="form-label">Template Name *</label>
                  <input
                    name="template_name"
                    onChange={handleTemplateChange}
                    value={newTemplate.template_name}
                    className="form-control"
                    placeholder="e.g., Lab Report"
                    type="text"
                    required
                  />
                  <small className="text-muted">Internal name for reference</small>
                </div>

                <div className="col-md-3 mb-3">
                  <label className="form-label">Template ID *</label>
                  <input
                    name="template_id"
                    onChange={handleTemplateChange}
                    value={newTemplate.template_id}
                    className="form-control"
                    placeholder="e.g., 1133793038628453"
                    type="text"
                    required
                  />
                  <small className="text-muted">From Fast2SMS dashboard</small>
                </div>

                {/* ✅ NEW: Message ID Field */}
                <div className="col-md-2 mb-3">
                  <label className="form-label">Message ID *</label>
                  <input
                    name="message_id"
                    onChange={handleTemplateChange}
                    value={newTemplate.message_id}
                    className="form-control"
                    placeholder="e.g., 9546"
                    type="text"
                    required
                  />
                  <small className="text-muted">Fixed ID from Fast2SMS</small>
                </div>

                <div className="col-md-2 mb-3">
                  <label className="form-label">Module Type *</label>
                  <select
                    name="module_type"
                    onChange={handleTemplateChange}
                    value={newTemplate.module_type}
                    className="form-select"
                    required
                  >
                    <option value="lab">Lab</option>
                    <option value="lab_pdf">lab_pdf</option>
                    <option value="opd">OPD</option>
                    <option value="ipd">IPD</option>
                    <option value="pharmacy">Pharmacy</option>
                  </select>
                </div>

                <div className="col-md-2 mb-3">
                  <label className="form-label">Template Content</label>
                  <input
                    name="template_content"
                    onChange={handleTemplateChange}
                    value={newTemplate.template_content}
                    className="form-control"
                    placeholder="Template preview"
                    type="text"
                  />
                  <small className="text-muted">Optional description</small>
                </div>

                <div className="col-md-12 mb-3">
                  {isEditing ? (
                    <>
                      <button type="submit" className="btn btn-warning btn-sm me-2">
                        <i className="ri-save-line align-middle me-1"></i> Update Template
                      </button>
                      <button 
                        type="button" 
                        className="btn btn-secondary btn-sm"
                        onClick={handleCancelEdit}
                      >
                        <i className="ri-close-line align-middle me-1"></i> Cancel
                      </button>
                    </>
                  ) : (
                    <button type="submit" className="btn btn-success btn-sm">
                      <i className="ri-add-line align-middle me-1"></i> Add Template
                    </button>
                  )}
                </div>
              </div>
            </form>

            {/* ✅ Help Text */}
            <div className="alert alert-info mb-4">
              <strong><i className="ri-information-line me-1"></i>How to get Template ID & Message ID:</strong>
              <ol className="mb-0 mt-2">
                <li>Login to <a href="https://www.fast2sms.com/" target="_blank" rel="noopener noreferrer">Fast2SMS Dashboard</a></li>
                <li>Go to <strong>WhatsApp Templates</strong> section</li>
                <li>Find your approved template</li>
                <li>Copy both <strong>Template ID</strong> (long number) and <strong>Message ID</strong> (short number)</li>
                <li>Paste them in the form above</li>
              </ol>
            </div>

            {/* Templates List */}
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th style={{width: '15%'}}>Template Name</th>
                    <th style={{width: '20%'}}>Template ID</th>
                    <th style={{width: '10%'}}>Message ID</th>
                    <th style={{width: '10%'}}>Module</th>
                    <th style={{width: '30%'}}>Content</th>
                    <th style={{width: '15%'}}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {templates.length > 0 ? (
                    templates.map((template) => (
                      <tr key={template.id}>
                        <td><strong>{template.template_name}</strong></td>
                        <td>
                          <span className="badge bg-info" style={{fontSize: '0.75rem'}}>
                            {template.template_id}
                          </span>
                        </td>
                        {/* ✅ Display Message ID */}
                        <td>
                          <span className="badge bg-success" style={{fontSize: '0.75rem'}}>
                            {template.message_id || 'N/A'}
                          </span>
                        </td>
                        <td>
                          <span className="badge bg-primary">
                            {template.module_type.toUpperCase()}
                          </span>
                        </td>
                        <td>
                          <small className="text-muted">{template.template_content || 'No description'}</small>
                        </td>
                        <td>
                          <button 
                            className="btn btn-warning btn-sm me-2"
                            onClick={() => handleEditTemplate(template)}
                            title="Edit Template"
                          >
                            <i className="ri-edit-line"></i>
                          </button>
                          <button 
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteTemplate(template.id)}
                            title="Delete Template"
                          >
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="text-center text-muted py-4">
                        <i className="ri-file-list-line" style={{fontSize: '2rem'}}></i>
                        <p className="mb-0 mt-2">No templates added yet. Add your first template above.</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderModuleSettings = () => {
    const currentSettings = moduleSettings[activeModuleType];
    
    const settingsConfig = {
      lab: [
        { key: 'report_to_patient', label: 'Lab Report to Patient', description: 'Send lab report PDF via WhatsApp' },
        { key: 'bill_pdf_to_patient', label: 'Lab Bill PDF to Patient', description: 'Send lab bill PDF via WhatsApp' },
        { key: 'whatsapp_notification', label: 'Lab WhatsApp Notification', description: 'Send WhatsApp notification for lab tests' },
      ],
      opd: [
        { key: 'bill_to_patient', label: 'OPD Bill to Patient', description: 'Send OPD bill via WhatsApp' },
        { key: 'digital_prescription', label: 'Digital Prescription', description: 'Send digital prescription via WhatsApp' },
        { key: 'whatsapp_notification', label: 'OPD WhatsApp Notification', description: 'Send WhatsApp notification for OPD' },
      ],
      ipd: [
        { key: 'admission_bill', label: 'Admission Bill', description: 'Send IPD admission bill via WhatsApp' },
        { key: 'bill_pdf', label: 'IPD Bill PDF', description: 'Send IPD bill PDF via WhatsApp' },
        { key: 'whatsapp_notification', label: 'IPD WhatsApp Notification', description: 'Send WhatsApp notification for IPD' },
      ],
      pharmacy: [
        { key: 'sale_pdf_bill', label: 'Sale PDF Bill', description: 'Send pharmacy sale bill PDF via WhatsApp' },
        { key: 'return_pdf_bill', label: 'Return PDF Bill', description: 'Send pharmacy return bill PDF via WhatsApp' },
        { key: 'sale_whatsapp', label: 'Sale WhatsApp Notification', description: 'Send WhatsApp notification for pharmacy sales' },
      ],
    };

    return (
      <div className="row">
        <div className="col-xxl-12">
          <div className="card">
            <div className="card-body">
              <div className="d-flex justify-content-between align-items-center mb-4">
                <h5 className="card-title mb-0">
                  {activeModuleType.toUpperCase()} - WhatsApp Settings
                </h5>
                <div className="btn-group" role="group">
                  {['lab', 'opd', 'ipd', 'pharmacy'].map((type) => (
                    <button
                      key={type}
                      type="button"
                      className={`btn ${activeModuleType === type ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setActiveModuleType(type)}
                    >
                      {type.toUpperCase()}
                    </button>
                  ))}
                </div>
              </div>

              <div className="row">
                {settingsConfig[activeModuleType].map((setting) => (
                  <div className="col-md-12 mb-3" key={setting.key}>
                    <div className="card border">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <h6 className="mb-1">{setting.label}</h6>
                            <small className="text-muted">{setting.description}</small>
                          </div>
                          <div className="form-check form-switch form-switch-lg">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              checked={currentSettings[setting.key]}
                              onChange={() => handleToggleChange(activeModuleType, setting.key)}
                              id={`${activeModuleType}_${setting.key}`}
                            />
                            <label 
                              className="form-check-label" 
                              htmlFor={`${activeModuleType}_${setting.key}`}
                            >
                              {currentSettings[setting.key] ? 'Active' : 'Inactive'}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0">WhatsApp Setup (Fast2SMS)</h4>
              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item"><a href="/">Dashboard</a></li>
                  <li className="breadcrumb-item active">WhatsApp Setup</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        {/* Main Tab Navigation */}
        <div className="row mb-3">
          <div className="col-12">
            <ul className="nav nav-tabs nav-tabs-custom" role="tablist">
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'configuration' ? 'active' : ''}`}
                  onClick={() => setActiveTab('configuration')}
                  type="button"
                >
                  <i className="ri-settings-3-line me-1"></i>
                  Configuration
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${activeTab === 'modules' ? 'active' : ''}`}
                  onClick={() => setActiveTab('modules')}
                  type="button"
                >
                  <i className="ri-toggle-line me-1"></i>
                  Module Settings
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Tab Content */}
        {activeTab === 'configuration' ? renderConfigurationTab() : renderModuleSettings()}

      </div>
    </div>
  );
}

export default WhatsappSetup;